<!--
 * @Author: LiZhiWei
 * @Date: 2026-01-20 10:51:08
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-01-30 09:30:38
 * @Description: 
-->
<template>
  <section
    id="partnership"
    ref="partnershipRef"
    class="partnership transition-all duration-1000 ease-out landing-container py-60px overflow-hidden lt-sm:py-60px lt-sm:px-0"
    :class="[isPartnershipVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-50px']"
  >
    <div class="partnership-header flex-center gap-32px mb-40px lt-sm:mb-40px lt-sm:gap-30px">
      <div
        class="partnership-line-left h-2px w-320px bg-[linear-gradient(90deg,transparent_0%,#E5E9F5_100%)] lt-sm:w-85px"
      ></div>
      <h2
        class="partnership-title pf-sc-regular text-center font-s-18px lh-21px text-#9CA0A7 whitespace-nowrap lt-sm:font-s-28px"
      >
        与合作伙伴携手，深入产业共创价值
      </h2>
      <div
        class="partnership-line-right h-2px w-320px bg-[linear-gradient(90deg,#E5E9F5_0%,transparent_100%)] lt-sm:w-85px"
      ></div>
    </div>

    <div class="partnership-content relative flex flex-col gap-0px -mt-24px">
      <inspira-marquee class="partnership-marquee-row1 [--duration:80s] [--gap:24px] mb--31px">
        <div
          v-for="partner in partnersRow1"
          :key="partner.name"
          class="partner-item flex-center h-80px w-200px bg-white rounded-8px shadow-[0_2px_8px_2px_rgba(0,0,0,0.06)] px-24px lt-sm:h-105px lt-sm:w-290px"
        >
          <img :src="partner.logo" :alt="`${partner.name} logo`" class="wh-full object-contain" />
        </div>
      </inspira-marquee>
      <InspiraMarquee
        reverse
        class="partnership-marquee-row2 [--duration:80s] [--delay:-20s] [--gap:24px]"
      >
        <div
          v-for="partner in partnersRow2"
          :key="partner.name"
          class="partner-item flex-center h-80px w-200px bg-white rounded-8px shadow-[0_2px_8px_2px_rgba(0,0,0,0.06)] px-24px lt-sm:h-105px lt-sm:w-290px"
        >
          <img :src="partner.logo" :alt="`${partner.name} logo`" class="wh-full object-contain" />
        </div>
      </InspiraMarquee>
      <div
        class="partnership-mask-left pointer-events-none absolute inset-y-0 left-0 w-1/4 bg-[linear-gradient(to_right,#fff,transparent)]"
      ></div>
      <div
        class="partnership-mask-right pointer-events-none absolute inset-y-0 right-0 w-1/4 bg-[linear-gradient(to_left,#fff,transparent)]"
      ></div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { partnersRow1, partnersRow2 } from '@/constants/common'
  const partnershipRef = ref<HTMLElement | null>(null)
  const { isVisible: isPartnershipVisible } = useScrollReveal(partnershipRef)
</script>

<style scoped>
  @media screen and (min-width: 1480px) {
    .partnership {
      padding-left: calc((100vw - 1480px) / 2);
      padding-right: calc((100vw - 1480px) / 2);
    }
  }
</style>
